export default "/images/vendor/flag-icons/flags/4x3/sh-ac.svg?33772744760b05b228b34ba4c07c308b";